import { MessageSquare } from "lucide-react";
import { Button } from "@/components/ui/button";
import { useNavigate } from "react-router-dom";

interface ChatIconProps {
  unreadCount: number;
}

export function ChatIcon({ unreadCount }: ChatIconProps) {
  const navigate = useNavigate();

  return (
    <Button
      variant="ghost"
      size="icon"
      className="relative h-10 w-10 sm:h-9 sm:w-9"
      onClick={() => navigate("/communications?tab=messages")}
    >
      <MessageSquare className="h-4.5 w-4.5" />
      {unreadCount > 0 && (
        <span className="absolute -top-0.5 -right-0.5 h-4.5 min-w-[18px] rounded-full bg-destructive text-destructive-foreground text-[10px] font-bold flex items-center justify-center px-1">
          {unreadCount}
        </span>
      )}
    </Button>
  );
}
